
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[authorID]/courses",
      function () {
        return require("private-next-pages/[authorID]/courses.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[authorID]/courses"])
      });
    }
  